<script setup lang="ts">
import { computed, type Component } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{
  to: string
  icon: Component
  label: string
  active: boolean
}>()

const router = useRouter()
const href = computed(() => router.resolve(props.to).href)

function onClick(event: MouseEvent) {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
  // A dialog that never finished closing preventDefault()s this click from
  // the document capture phase. router-link then refuses to navigate.
  event.preventDefault()
  void router.push(props.to)
}
</script>

<template>
  <a
    :href="href"
    class="group flex items-center gap-2.5 rounded-lg px-2.5 py-2 text-sm font-medium transition"
    :class="active ? 'bg-forest-50 text-forest-700' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'"
    :aria-current="active ? 'page' : undefined"
    @click="onClick"
  >
    <component
      :is="icon"
      class="h-[18px] w-[18px] shrink-0"
      :class="active ? 'text-forest' : 'text-gray-400 group-hover:text-gray-500'"
    />
    {{ label }}
  </a>
</template>
